import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useMediaQuery } from '@/hooks/use-media-query'

interface PageHeaderProps {
  title: string
  description?: string
  showBackButton?: boolean
  className?: string
}
export function PageHeader({ title, description, showBackButton = true, className }: PageHeaderProps) {
  const isSmAndDown = useMediaQuery('(max-width:768px)')

  return (
    <div
      className={cn(
        'relative text-white p-4 sm:p-6 mt-3 rounded-2xl transition-all shadow-card gradient-background',
        className
      )}
      style={{
        // Overlay escuro sutil aplicado direto no style para melhorar legibilidade
        backgroundImage: 'linear-gradient(rgba(0,0,0,0.08), rgba(0,0,0,0.18)), linear-gradient(to right, hsl(var(--primary)), hsl(var(--accent)))'
      }}
    >
      <div className={cn('relative flex items-center gap-3 min-w-full', isSmAndDown && 'flex-col')}>
        {showBackButton && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => {
              window.location.href = '/chat'
            }}
            className={cn(
              'bg-white/15 hover:bg-white/25 text-white border border-white/30 backdrop-blur-sm gap-2 self-center shrink-0',
              isSmAndDown && 'min-w-full'
            )}
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar
          </Button>
        )}
        <div className={cn('flex flex-col justify-center min-w-0 flex-1', !isSmAndDown && 'px-1')}>
          <h1 className="text-xl sm:text-2xl font-semibold text-white drop-shadow-md leading-tight">{title}</h1>
          {description && <p className="text-sm sm:text-base text-white/95 mt-1 drop-shadow-md leading-snug">{description}</p>}
        </div>
      </div>
    </div>
  )
}
